// Mongo's timezone-less timestamps are UTC, never the browser's local timezone.
export const prospectDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  const iso = /(?:Z|[+-]\d{2}:\d{2})$/i.test(value) ? value : `${value}Z`;
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatProspectTime = (value, lang = 'pt') => {
  const date = prospectDate(value);
  return date ? date.toLocaleString({ pt: 'pt-PT', en: 'en-GB', fr: 'fr-FR' }[lang.slice(0, 2)] || 'pt-PT', {
    weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Atlantic/Cape_Verde',
  }) : '';
};

export const toCvInput = (value) => {
  const date = prospectDate(value);
  // Cape Verde stays at UTC-01:00 throughout the year.
  return date ? new Date(date.getTime() - 3600000).toISOString().slice(0, 16) : '';
};

export const fromCvInput = (value) => value ? new Date(`${value}-01:00`).toISOString() : null;
const CV_TZ = 'Atlantic/Cape_Verde';
const TZ_COUNTRY = { 'Europe/Rome': 'Itália', 'Europe/Lisbon': 'Portugal', 'Europe/Paris': 'França', 'Europe/Madrid': 'Espanha', 'Europe/London': 'Reino Unido', 'Europe/Amsterdam': 'Países Baixos', 'Europe/Brussels': 'Bélgica', 'Europe/Luxembourg': 'Luxemburgo', 'Europe/Zurich': 'Suíça', 'Europe/Berlin': 'Alemanha', 'America/New_York': 'EUA', 'America/Sao_Paulo': 'Brasil', 'Africa/Dakar': 'Senegal', 'Atlantic/Azores': 'Açores' };

export const browserTz = () => Intl.DateTimeFormat().resolvedOptions().timeZone || CV_TZ;

const hm = (d, tz) => d.toLocaleString('pt-PT', { timeZone: tz, hour: '2-digit', minute: '2-digit' });
const dayOf = (d, tz) => d.toLocaleDateString('pt-PT', { timeZone: tz, weekday: 'short', day: '2-digit', month: '2-digit' });

export const cvTime = (value) => { const d = prospectDate(value); return d ? hm(d, CV_TZ) : ''; };

export const localConversion = (value) => {
  const d = prospectDate(value);
  const tz = browserTz();
  if (!d || hm(d, tz) === hm(d, CV_TZ)) return null;
  const sameDay = dayOf(d, tz) === dayOf(d, CV_TZ);
  const where = TZ_COUNTRY[tz] || tz.split('/').pop().replace(/_/g, ' ');
  return `${hm(d, CV_TZ)} em Cabo Verde = ${sameDay ? '' : `${dayOf(d, tz)}, `}${hm(d, tz)} na sua hora local (${where})`;
};
